$(document).on('change', '.fileInput input:file', function () {
    var input = $(this),
        numFiles = input.get(0).files ? input.get(0).files.length : 1,
        label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
    input.trigger('fileselect', [numFiles, label]);
});

$(function () {
    $('.fileInput input:file').on('fileselect', function (event, numFiles, label) {

        var input = $(this).parent().find('.fileInput--text');
        var log = numFiles > 1 ? numFiles + ' files selected' : label;

        input.text(log);
    });
});